 

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';




export abstract class RolesData {
  //abstract fireRequest(data: Department, method: string): Observable<any>;
  abstract list(url: string): Observable<any[]>;
  abstract create(url: string,data: any): Observable<any>;
  abstract createTable(url: string,data: any,options:any): Observable<any>;
  abstract update(url: string,data: any): Observable<any>;
  abstract updateWithHeaders(url: string,data: any): Observable<any>;
  abstract delete(url: string): Observable<any>;
  abstract getById(url: string): Observable<any>;
  abstract listWithHeaders(url: string): Observable<any>;
  abstract searchList(url: string,data:any): Observable<any>;
}
